export const apiEndPoint = {
  apiUrl: process.env.REACT_APP_API_END_POINT_URL || 'http://gis:3001/v1'
};
